import {
  STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_BEGIN:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          getImagesExpertisePending: true,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            errorImagesExpertise: null
          }
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_SUCCESS:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          getImagesExpertisePending: false,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            ...action.data,
            errorImagesExpertise: null,
            saveData: {
              ...state.takingCarManagement.fastStockLoading.saveData,
              files: []
            }
          }
        }
      }

    case STOCK_TAKING_CAR_MANAGEMENT_GET_IMAGES_EXPERTISE_FAILURE:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          getImagesExpertisePending: false,
          fastStockLoading: {
            ...state.takingCarManagement.fastStockLoading,
            errorImagesExpertise: "Error al cargar las imágenes de Peritador."
          }
        }
      }
    default:
      return state
  }
}
